var React = require('react');

function ArrowUpRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 11L11 1","stroke":"#3D3938","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M1 1H11V11","stroke":"#3D3938","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowUpRight.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = ArrowUpRight;

ArrowUpRight.default = ArrowUpRight;
